import { useEffect, useState } from 'react';
import {
  applyConsentSelection,
  hasGdprDecision,
  readGdprConsent,
  saveGdprConsent,
} from '../lib/gdpr-consent';

export function Footer() {
  const [showModal, setShowModal] = useState(false);
  const [statistics, setStatistics] = useState(true);
  const [analyticsMarketing, setAnalyticsMarketing] = useState(true);

  useEffect(() => {
    const existing = readGdprConsent();
    if (!existing) {
      setStatistics(true);
      setAnalyticsMarketing(true);
      setShowModal(true);
      return;
    }

    setStatistics(existing.statistics);
    setAnalyticsMarketing(existing.analyticsMarketing);
  }, []);

  const persistConsent = (next: { statistics: boolean; analyticsMarketing: boolean }) => {
    const saved = saveGdprConsent(next);
    applyConsentSelection(saved);
    window.dispatchEvent(new Event('gdpr-consent-updated'));
    setStatistics(saved.statistics);
    setAnalyticsMarketing(saved.analyticsMarketing);
    setShowModal(false);
  };

  const openSettings = () => {
    const existing = readGdprConsent();
    if (existing) {
      setStatistics(existing.statistics);
      setAnalyticsMarketing(existing.analyticsMarketing);
    }
    setShowModal(true);
  };

  return (
    <>
      <footer className="border-t px-6 py-4 text-center text-sm site-footer">
        <p>&copy; {new Date().getFullYear()} Gerada Tur. Toate drepturile rezervate.</p>
        <button
          type="button"
          className="mt-2 text-xs underline hover:no-underline"
          onClick={openSettings}
        >
          Setări GDPR cookie-uri
        </button>
      </footer>

      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
          <div className="w-full max-w-xl rounded-lg bg-white p-5 shadow-xl">
            <h2 className="text-lg font-semibold">Preferințe GDPR</h2>
            <p className="mt-1 text-sm text-gray-600">
              Selectează categoriile de cookie-uri pe care le accepți. Categoria esențiale este obligatorie.
            </p>

            <div className="mt-4 space-y-3">
              <label className="flex items-start gap-3 rounded border p-3">
                <input id="gdpr-essential" name="gdpr-essential" type="checkbox" checked disabled className="mt-1" />
                <span>
                  <span className="block font-medium">Esențiale</span>
                  <span className="text-xs text-gray-600">Necesare pentru funcționarea aplicației și securitate.</span>
                </span>
              </label>

              <label className="flex items-start gap-3 rounded border p-3">
                <input
                  id="gdpr-statistics"
                  name="gdpr-statistics"
                  type="checkbox"
                  checked={statistics}
                  onChange={(e) => setStatistics(e.target.checked)}
                  className="mt-1"
                />
                <span>
                  <span className="block font-medium">Statistici</span>
                  <span className="text-xs text-gray-600">Măsurarea traficului și performanței paginilor.</span>
                </span>
              </label>

              <label className="flex items-start gap-3 rounded border p-3">
                <input
                  id="gdpr-analytics-marketing"
                  name="gdpr-analytics-marketing"
                  type="checkbox"
                  checked={analyticsMarketing}
                  onChange={(e) => setAnalyticsMarketing(e.target.checked)}
                  className="mt-1"
                />
                <span>
                  <span className="block font-medium">Analiză și marketing</span>
                  <span className="text-xs text-gray-600">Măsurare campanii, personalizare și semnale publicitare.</span>
                </span>
              </label>
            </div>

            <div className="mt-5 flex flex-wrap gap-2">
              <button
                type="button"
                onClick={() => persistConsent({ statistics: false, analyticsMarketing: false })}
                className="rounded border px-3 py-2 text-sm hover:bg-gray-50"
              >
                Refuz opționale
              </button>
              <button
                type="button"
                onClick={() => persistConsent({ statistics, analyticsMarketing })}
                className="rounded bg-blue-600 px-3 py-2 text-sm text-white hover:bg-blue-700"
              >
                Salvează selecția
              </button>
              <button
                type="button"
                onClick={() => persistConsent({ statistics: true, analyticsMarketing: true })}
                className="rounded border px-3 py-2 text-sm hover:bg-gray-50"
              >
                Accept toate
              </button>
              {hasGdprDecision() && (
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="ml-auto rounded border px-3 py-2 text-sm hover:bg-gray-50"
                >
                  Închide
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
